var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.35,
    d: "M13.3406 2.65931C12.4619 1.78064 11.0373 1.78064 10.1586 2.65931L2.80528 9.99864C2.60395 10.2 2.46995 10.458 2.42128 10.7386L2.01128 13.1166C1.92261 13.6313 2.36995 14.078 2.88461 13.9886L5.23462 13.58C5.51328 13.5313 5.77062 13.398 5.97062 13.198L13.3406 5.84064C14.2199 4.96197 14.2199 3.53797 13.3406 2.65931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.7168 4.09602L11.8988 7.27802L13.2215 5.96002L10.0395 2.77802L8.7168 4.09602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.26128 11.6667L2.01128 13.1167C1.92261 13.6314 2.36995 14.078 2.88461 13.9887L4.33195 13.7367L2.26128 11.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.1f091be71d0eab0c7204f7080646098a.svg";
export { ForwardRef as ReactComponent };